import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABEL } from "@/lib/format";
import { ScrollText } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { acceptInvite } = useAuth();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get(`/invites/${token}`)
      .then(({ data }) => { setInfo(data); setName(data.name || ""); })
      .catch((e) => setErr(apiErr(e.response?.data?.detail)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try { await acceptInvite({ token, name, password }); navigate("/inicio"); }
    catch (e) { setErr(apiErr(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-ec-bg p-6">
      <div className="w-full max-w-md bg-white rounded-[16px] shadow-[0_8px_30px_rgb(0,0,0,0.06)] p-8">
        <div className="flex items-center gap-3 mb-6">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-ec-green">
            <ScrollText size={20} strokeWidth={1.5} className="text-ec-gold" />
          </span>
          <span className="font-heading text-2xl text-ec-green">ImoDesk</span>
        </div>
        {err && <div className="mb-4 text-sm bg-red-50 text-red-700 border border-red-200 rounded-lg px-3 py-2">{err}</div>}
        {info ? (
          <>
            <h2 className="font-heading text-xl text-ec-green">Juntar-se a {info.agency_name}</h2>
            <p className="text-sm text-slate-500 mb-6">
              Convite para <b>{info.email}</b> como {ROLE_LABEL[info.role]}.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label>O seu nome</Label>
                <Input value={name} onChange={(e) => setName(e.target.value)} required className="mt-1.5" data-testid="inv-name" />
              </div>
              <div>
                <Label>Definir palavra-passe</Label>
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" data-testid="inv-password" />
              </div>
              <button type="submit" disabled={loading} data-testid="inv-submit"
                className="w-full bg-ec-green text-white py-2.5 rounded-lg font-semibold hover:bg-ec-greenDark transition-colors disabled:opacity-60">
                {loading ? "A entrar…" : "Entrar na agência"}
              </button>
            </form>
          </>
        ) : (
          !err && <p className="text-slate-500">A carregar convite…</p>
        )}
      </div>
    </div>
  );
}
